<template>
  <div v-if="isLoadingInProgress" class="flex items-center justify-center">
    <Loader color="#64748B" width="50px" height="50px" />
  </div>
  <div v-else>
    <div class="transaction-explorer mt-14 pb-[60px]"
      v-if="transactionData && Object.keys(transactionData).length">
      <div class="mb-[10px]">
        <TxTitleComponent :txType="transactionData.type" />

        <div class="flex max-w-max relative w-auto">
          <p class="font-jost-regular text-blue-light text-[25px] leading-[36px] break-all w-full text-left">
            {{ getHash() }}
            <span class="inline-block cursor-pointer" title="Copy hash">
              <CopyIcon :isActive="checkIfIsEqual(getHash())" @click="copy(getHash())" title="Copy hash"
                class="h-[33px] ml-2 inline-block cursor-pointer" />
            </span>
          </p>
        </div>
      </div>

      <AttestOverview v-if="transactionData.type ==='attestCommit'" :transactionData="transactionData"
        :transactionRefHash="transactionRefHash" />
      <CoinReceiveOverview v-if="transactionData.type === 'coin' || transactionData.type === 'nft'" :transactionData="transactionData"
        :transactionRefHash="transactionRefHash" />
      <CounterpartyOverview v-if="transactionData.type ==='stack'" :transactionData="transactionData"
        :transactionRefHash="transactionRefHash" />
      <MintNftOverview v-if="transactionData.type === 'nftMint'" :signedBy="signedBy" :transactionData="transactionData"
        :transactionRefHash="transactionRefHash" />
      <CreateProxyOverview v-if="transactionData.type === 'proxyCreate'" :transactionData="transactionData"
        :transactionRefHash="transactionRefHash" />
      <CreateProxyMintOverview v-if="transactionData.type === 'create_proxy_mint'" :transactionData="transactionData"
        :transactionRefHash="transactionRefHash" />

      <Paragraph class="text-blue-dark font-jost-regular text-[18px] mt-14" text="Transaction" />

      <div v-if="txUnorderedData && Object.keys(txUnorderedData).length">
        <TransactionJson :transaction="txUnorderedData" />
      </div>
      <div v-if="transactionData.payload && Object.keys(transactionData.payload).length">
        <Paragraph class="text-blue-dark font-jost-regular text-[18px] mt-10" text="Payload" />

        <PayloadJson :payload="transactionData.payload" />
      </div> 
    </div>
    <Paragraph text="We couldn't find any results.." class="text-blue-dark text-lg mt-5 float-left" v-else />
  </div>
</template>

<script>
import Paragraph from "@/components/web/ParagraphComponent";
import api from '@/helpers/api';
import string from '@/helpers/string';
import CopyIcon from "@/components/svg/CopyIcon.vue";
import Loader from '@/components/common/Loader.vue';
import CounterpartyOverview from "@/components/common/overview/CounterpartyOverview.vue";
import MintNftOverview from "@/components/common/overview/MintNftOverview.vue";
import AttestOverview from "@/components/common/overview/AttestOverview.vue";
import CoinReceiveOverview from "@/components/common/overview/CoinReceiveOverview.vue";
import TxTitleComponent from "@/components/common/TxTitleComponent.vue";
import PayloadJson from "@/components/common/overview/PayloadJson.vue";
import CreateProxyOverview from "@/components/common/overview/CreateProxyOverview.vue";
import CreateProxyMintOverview from "@/components/common/overview/CreateProxyMintOverview.vue";
import TransactionJson from "@/components/common/overview/TransactionJson.vue";

import moment from 'moment';

export default {
  name: "TransactionComponent",
  components: {
    Paragraph,
    CopyIcon,
    CounterpartyOverview,
    MintNftOverview,
    TxTitleComponent,
    CoinReceiveOverview,
    PayloadJson,
    TransactionJson,
    CreateProxyOverview,
    AttestOverview,
    CreateProxyMintOverview,
    Loader,
  },
  props: {
    txRefHash: {
      required: true
    }
  },
  data: () => {
    return {
      isLoadingInProgress: false,
      copied: '',
      transactionRefHash: "",
      isLoading: false,
      lastPath: null,
      transactionData: {},
      txUnorderedData: {},
      signedBy: '',
      uvtOrderedSample: {
        "amtCoin": null,
        "from": null,
        "to": null,
        "blockNumber": null,
        "chainNumber": null,
        "publicKey": null,
        "refHash": null,
      },
      uatOrderedSample: {
        "uatData": null,
        "signature": null,
      },
      uatDataOrderedSample: {
        // "groupType": null,
        "blockNumber": null,
        "chainNumber": null,
        "publicKey": null,
        "refHash": null,
      },
      uatDataOrderedSampleMintNft: {
        // "groupType": null,
        "blockNumber": null,
        "chainNumber": null,
        "publicKey": null,
        "refHash": null,
      },
      uatDataOrderedSampleAttest: {
        // "groupType": null,
        "blockNumber": null,
        "chainNumber": null,
        "publicKey": null,
        "refHash": null,
      }
    }
  },
  computed: {
    transactionJson() {
      if (this.transactionData.uat) {
        return this.filteredUatData;
      }

      return { uvtData: this.uvtOrderedSample };
    },
    routeName() {
      return this.$route.name
    },


    filteredUatData() {
      const uatData = this.transactionData.uat;
      if (!uatData) return {};
      const filteredUatData = Object.assign({}, uatData);
      delete filteredUatData.overview;
      return filteredUatData;
    }
  },
  created() {
    this.lastPath = this.$router.options.history.state.back;
    if (this.txRefHash) {
      this.searchByTxRefHash(this.txRefHash);
      return;
    }
  },
  methods: {
    getNftTitle(metadata) {
      const title = this.findItemStartingWith(metadata, 't:');
      return title ? title : '';
    },
    getCreatorName(metadata) {
      const artistName = this.findItemStartingWith(metadata, 'u:');
      return artistName ? artistName : '';
    },
    getNftFileUrl(metadata) {
      const fileUrl = this.findItemStartingWith(metadata, 'i:');
      return fileUrl ? fileUrl : '';
    },
    findItemStartingWith(arr, keyName) {
      if (!arr || !arr.length) return null;

      for (const item of arr) {
        if (item.startsWith(keyName)) {
          return item.substring(2);
        }
      }
      return null;
    },
    getTxCreationDate() {
      const createdAt = this.transactionData.uat.overview.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    getTitle() {
      return this.routeName === "transaction" ? "AppCommitHash" : "RefHash"
    },
    getHash() {
      return this.transactionRefHash;
    },
    goBack() {
      this.$router.push({name: 'search-result'})
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
    setupTransactionData() {
      if (!this.transactionData || !Object.keys(this.transactionData).length) return;

      // this.transactionData.type = this.getTransactionTypeFromValues(this.transactionData);
      this.txUnorderedData = { ...this.transactionData };
      this.transactionRefHash = this.txRefHash || this.transactionData.refHash || '';
      this.signedBy = this.transactionData.signedBy || '';

      const tx = this.transactionData;
      const type = tx.type;

      const fieldMap = (template, overrides = {}) => {
        const result = {};
        for (const key in template) {
          if (key in overrides) {
            result[key] = overrides[key];
            continue;
          }
          result[key] = tx[key] ?? null;
        }
        return result;
      };

      const sharedOverrides = {
        blockNumber: tx.block ?? null,
      };

      const coinValue = this.getCoinValueAmount(tx);

      if (type === 'coin' || type === 'nft') {
        this.txUnorderedData = fieldMap(this.uvtOrderedSample, {
          ...sharedOverrides,
          amtCoin: coinValue ?? tx.amtCoin ?? null,
        });
        return;
      }
      
      if (type === 'proxyCreate') {
        this.txUnorderedData = fieldMap(this.uvtOrderedSample, {
          ...sharedOverrides,
          amtCoin: coinValue ?? tx.amtCoin ?? null,
        });
        return;
      }

      if (type === 'attestCommit') {
        this.txUnorderedData = fieldMap(this.uatDataOrderedSampleAttest, {
          ...sharedOverrides,
          txType: type,
        });
        return;
      }

      if (type === 'nftMint') {
        this.txUnorderedData = fieldMap(this.uatDataOrderedSampleMintNft, {
          ...sharedOverrides,
          txType: type,
        });
      }
    },
    searchByTxRefHash(txRefHash) {
      this.isLoadingInProgress = true;

      return api.getTransactionDetailsByRefHash(txRefHash)
        .then((res) => {
          this.transactionData = res.data.result;
          this.setupTransactionData();

          this.isLoadingInProgress = false;
        })
        .catch(() => {
          this.isLoadingInProgress = false;
        })
    },
    getTransactionTypeFromValues(tx) {
      if (!tx || !Array.isArray(tx.values)) {
        return tx?.type || '';
      }

      const hasCoin = tx.values.some((item) => item && item.type === 'coin');
      const hasNft = tx.values.some((item) => item && item.type === 'nft');

      if (hasCoin && hasNft) {
        return 'nft';
      }

      if (hasCoin && !hasNft) {
        return 'coin';
      }

      return tx.type || '';
    },
    getCoinValueAmount(tx) {
      if (!tx) {
        return null;
      }

      if (Array.isArray(tx.values)) {
        const coinValue = tx.values.find((item) => item && item.type === 'coin');
        return coinValue?.value ?? null;
      }

      return tx.value?.value ?? null;
    },
  }
}
</script>
<style>
.transaction-explorer .vjs-value {
  color: #2699FB !important;
  font-size: 18px;
  line-height: 26px;
  font-family: 'Jost-Regular', monospace !important;
}
.transaction-explorer .vjs-tree {
  font-size: 18px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
  color: #2699FB !important;
}
.transaction-explorer .vjs-key {
  font-family: 'Jost-Regular', monospace !important;
  color: #2699FB !important;
}
</style>
<style scoped>
.col {
  flex: 1;
  width: calc(100% / 2);
}
.t-results-body {
  padding: 28px 21px;
  border-radius: 8px;
}
.t-results-body .row:first-child {
  border-top: unset;
}

@media (max-width: 992px) {
 .t-results-body {
    display: flex;
    flex-direction: column;
    gap: 0;
 }
 .first__col__last__row {
    border-bottom: 1px solid #2699FB;
 }
}
</style>
